import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getService } from '../../api/Services';
import { getTraders } from '../../api/traders';
import AddTraderModal from './AddTraderModal';

function ServiceList() {
  const [TraderData, setTraderData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCountry, setFilterCountry] = useState('all');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOrderClick = () => {
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    console.log('Edit trader:', item);
    // TODO: Implement edit functionality
    alert('Edit functionality will be implemented with backend integration');
  };

  const handleDeleteClick = (item) => {
    if (window.confirm(`Are you sure you want to delete trader "${item.full_name}"?`)) {
      console.log('Delete trader:', item);
      // TODO: Implement delete functionality
      alert('Delete functionality will be implemented with backend integration');
    }
  };

  // Function to format date and remove time - handles ISO format
  const formatDateOnly = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    try {
      if (dateTimeString.includes('T')) {
        const datePart = dateTimeString.split('T')[0];
        return datePart;
      }
      
      if (dateTimeString.includes(' ')) {
        const datePart = dateTimeString.split(' ')[0];
        return datePart;
      }
      
      return dateTimeString;
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateTimeString;
    }
  };

  function getTradersLIst() {
    setLoading(true);
    getTraders((result) => {
      if (result.ok === 1) {
        setTraderData(result.result);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    getTradersLIst();
  }, []);

  const filteredData = TraderData.filter(item => {
    const matchesSearch = item.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.country?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.border_name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || 
                         item.status?.toLowerCase() === filterStatus.toLowerCase();
    const matchesCountry = filterCountry === 'all' || 
                          item.country?.toLowerCase().includes(filterCountry.toLowerCase());
    return matchesSearch && matchesStatus && matchesCountry;
  });

  // Get unique values for filters
  const uniqueCountries = [...new Set(TraderData.map(item => item.country))].filter(Boolean);
  const uniqueStatuses = [...new Set(TraderData.map(item => item.status))].filter(Boolean);

  // Calculate statistics
  const totalTraders = TraderData.length;
  const activeTraders = TraderData.filter(item => item.status?.toLowerCase() === 'active').length;
  const totalCountries = uniqueCountries.length;
  const totalBorders = [...new Set(TraderData.map(item => item.border_name))].filter(Boolean).length;

  const TraderCard = ({ item, index }) => (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{width: '40px', height: '40px'}}>
              <i className="bi bi-person-badge text-primary"></i>
            </div>
            <div className="flex-grow-1 min-w-0">
              <h6 className="mb-1 fw-bold text-truncate">{item.full_name}</h6>
              <small className="text-muted d-block">
                <i className="bi bi-hash me-1"></i>
                Trader #{index + 1}
              </small>
            </div>
          </div>
          <div className="flex-shrink-0">
            {item.status?.toLowerCase() === 'active' ? (
              <span className="badge bg-success">
                <i className="bi bi-check-circle me-1"></i>
                Active
              </span>
            ) : (
              <span className="badge bg-secondary">
                <i className="bi bi-pause-circle me-1"></i>
                {item.status || 'Inactive'}
              </span>
            )}
          </div>
        </div>

        <div className="row g-2 mb-3">
          <div className="col-6">
            <small className="text-muted d-block">Country</small>
            <small className="fw-medium">{item.country}</small>
          </div>
          <div className="col-6">
            <small className="text-muted d-block">Border</small>
            <small className="fw-medium">{item.border_name}</small>
          </div>
        </div>

        <div className="d-flex gap-2">
          <button
            onClick={() => handleEditClick(item)}
            className="btn btn-outline-primary btn-sm flex-fill"
          >
            <i className="bi bi-pencil me-1"></i>
            Edit
          </button>
          <button
            onClick={() => handleDeleteClick(item)}
            className="btn btn-outline-danger btn-sm flex-fill"
          >
            <i className="bi bi-trash me-1"></i>
            Delete
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          {/* Header */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h2 className="mb-1 fw-bold">Trader Management</h2>
                <p className="text-muted">Manage and track all registered traders</p>
              </div>
              <button 
                onClick={handleOrderClick} 
                className="btn btn-primary"
              >
                <i className="bi bi-plus-circle me-2"></i>
                Add Trader
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Total Traders</p>
                      <h3 className="mb-0 fw-bold">{totalTraders}</h3>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-people fs-4 text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Active Traders</p>
                      <h3 className="mb-0 fw-bold text-success">{activeTraders}</h3>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-person-check fs-4 text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Countries</p>
                      <h3 className="mb-0 fw-bold text-info">{totalCountries}</h3>
                    </div>
                    <div className="bg-info bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-globe fs-4 text-info"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Border Points</p>
                      <h3 className="mb-0 fw-bold text-warning">{totalBorders}</h3>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-signpost fs-4 text-warning"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filters and Search */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search by name, country, or border..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-3">
                  <select
                    className="form-select"
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    {uniqueStatuses.map((status, index) => (
                      <option key={index} value={status}>{status}</option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-md-3">
                  <select
                    className="form-select"
                    value={filterCountry}
                    onChange={(e) => setFilterCountry(e.target.value)}
                  >
                    <option value="all">All Countries</option>
                    {uniqueCountries.map((country, index) => (
                      <option key={index} value={country}>{country}</option>
                    ))}
                  </select>
                </div>

                <div className="col-12">
                  <div className="d-flex gap-2 flex-wrap align-items-center">
                    <button
                      onClick={() => setFilterStatus('all')}
                      className={`btn btn-sm ${filterStatus === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    >
                      All
                    </button>
                    <button
                      onClick={() => setFilterStatus('active')}
                      className={`btn btn-sm ${filterStatus === 'active' ? 'btn-success' : 'btn-outline-secondary'}`}
                    >
                      Active
                    </button>
                    <button
                      onClick={() => setFilterStatus('inactive')}
                      className={`btn btn-sm ${filterStatus === 'inactive' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                    >
                      Inactive
                    </button>
                    <button
                      onClick={getTradersLIst}
                      disabled={loading}
                      className="btn btn-sm btn-outline-secondary ms-auto"
                      title="Refresh"
                    >
                      <i className={`bi bi-arrow-clockwise ${loading ? 'spinner-border spinner-border-sm' : ''}`}></i>
                      {loading ? ' Loading...' : ' Refresh'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <i className="bi bi-people fs-1 text-muted"></i>
              <p className="text-muted mt-2">No traders found</p>
            </div>
          ) : (
            <>
              {/* Mobile Card View (visible on small and medium screens) */}
              <div className="d-block d-xl-none">
                {filteredData.map((item, index) => (
                  <TraderCard key={index} item={item} index={index} />
                ))}
              </div>

              {/* Desktop Table View (visible on extra large screens) */}
              <div className="card border-0 shadow-sm d-none d-xl-block">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '60px'}}>#</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '200px'}}>Trader Name</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '120px'}}>Country</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '150px'}}>Border</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Status</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '120px'}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>
                              <span className="fw-medium">#{index + 1}</span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-person-badge text-primary small"></i>
                                </div>
                                <span className="fw-medium text-truncate" style={{maxWidth: '150px'}} title={item.full_name}>
                                  {item.full_name}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-globe text-info small"></i>
                                </div>
                                <span className="text-truncate" style={{maxWidth: '100px'}} title={item.country}>
                                  {item.country}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-warning bg-opacity-10 text-warning">
                                <i className="bi bi-signpost me-1"></i>
                                {item.border_name}
                              </span>
                            </td>
                            <td>
                              {item.status?.toLowerCase() === 'active' ? (
                                <span className="badge bg-success">
                                  <i className="bi bi-check-circle me-1"></i>
                                  Active
                                </span>
                              ) : (
                                <span className="badge bg-secondary">
                                  <i className="bi bi-pause-circle me-1"></i>
                                  {item.status || 'Inactive'}
                                </span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <button 
                                  onClick={() => handleEditClick(item)}
                                  className="btn btn-sm btn-outline-primary" 
                                  title="Edit"
                                >
                                  <i className="bi bi-pencil"></i>
                                </button>
                                <button 
                                  onClick={() => handleDeleteClick(item)}
                                  className="btn btn-sm btn-outline-danger" 
                                  title="Delete"
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Footer */}
          <div className="mt-3 text-center text-muted small">
            Showing {filteredData.length} of {TraderData.length} traders
          </div>
        </div>
      </div>

      <AddTraderModal 
        show={showModal} 
        handleClose={handleCloseModal} 
      />
    </div>
  );
}

export default ServiceList;